export default __webpack_public_path__ + "static/media/chef_hat.round.gray1.0b663058.svg";